import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTrasladosPendientes } from "../../../../../actions/traslados";
import FormContainer from "../../../forms/formContainer";
import AccidentDashboardContainer from "../../../accident/accidentDashboard/accidentDashboardContainer";
import PendientesTraslados from "./pendientesTraslados";
import snackbarUtils from "../../../../../utils/snackbarUtils";
import {
  buildAccidentFromTraslado,
  openAccidentFromTraslado,
  openFptEditableFromTraslado,
  openFptFromTraslado,
  openFptReadOnlyFromTraslado,
} from "../trasladosVisualizarUtils";

const PendientesTrasladosContainer = () => {
  const artContext = useSelector((state) => ({
    idArt:
      state.auth.artAsociada?.id ||
      state.arts.artPrestadores?.data?.[0]?.arts?.[0]?.id,
    artName:
      state.auth.artAsociada?.nombre ||
      state.arts.artPrestadores?.data?.[0]?.arts?.[0]?.nombre,
  }));
  const roles = useSelector((state) => state.auth.roles);
  const showAgente = Boolean(roles.AGENTETRASLADOS);
  const showGestor = Boolean(roles.GESTORSINIESTROS);
  const showTabs = showAgente && showGestor;
  const defaultView = showAgente ? "at" : "gs";
  const [selectedView, setSelectedView] = useState(defaultView);
  const [displayAccidents, setDisplayAccidents] = useState("block");

  const view = useMemo(() => {
    if (showTabs) {
      return selectedView;
    }
    return defaultView;
  }, [showTabs, selectedView, defaultView]);
  const dispatch = useDispatch();
  const pendientesState = useSelector((state) => state.traslados.pendientes);

  useEffect(() => {
    dispatch(getTrasladosPendientes(artContext.idArt));
  }, [dispatch, artContext.idArt]);

  const handleRefresh = () => {
    dispatch(getTrasladosPendientes(artContext.idArt));
  };

  const handleVisualizarSiniestro = (traslado) => {
    const accident = buildAccidentFromTraslado(traslado, artContext);
    if (!accident.idSiniestro || !accident.mlCloudCoreArtId) {
      snackbarUtils.error("No se pudo cargar la información del siniestro asociado.");
      return;
    }
    openAccidentFromTraslado(dispatch, accident);
    setDisplayAccidents("none");
  };

  const handleVisualizarTrasladoAt = (traslado) => {
    openFptFromTraslado(dispatch, traslado, openFptEditableFromTraslado, artContext);
  };

  const handleVisualizarTrasladoGs = (traslado) => {
    openFptFromTraslado(dispatch, traslado, openFptReadOnlyFromTraslado, artContext);
  };

  const handleAuditarTraslado = (traslado) => {
    openFptFromTraslado(dispatch, traslado, openFptEditableFromTraslado, artContext);
  };

  return (
    <>
      {displayAccidents === "none" && (
        <AccidentDashboardContainer setDisplayAccidents={setDisplayAccidents} />
      )}
      {displayAccidents !== "none" && (
        <>
          <PendientesTraslados
            showAgente={showAgente}
            showGestor={showGestor}
            showTabs={showTabs}
            selectedView={view}
            onChangeView={(_, value) => setSelectedView(value)}
            pendientesData={pendientesState}
            onRefresh={handleRefresh}
            onVisualizarSiniestro={handleVisualizarSiniestro}
            onVisualizarTrasladoAt={handleVisualizarTrasladoAt}
            onVisualizarTrasladoGs={handleVisualizarTrasladoGs}
            onAuditarTraslado={handleAuditarTraslado}
          />
          <FormContainer />
        </>
      )}
    </>
  );
};

export default PendientesTrasladosContainer;
